module.exports = "/_next/static/files/83292476a71f6f3733c0a99a3cd70d65.jpg";